import { render, staticRenderFns } from "./replenishment.vue?vue&type=template&id=2ac4cccc&"
import script from "./replenishment.vue?vue&type=script&lang=js&"
export * from "./replenishment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports